import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Suppliers/Suppliers/tables";
import headers from "../../../../Data/Tables/Suppliers/Suppliers/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_suppliers } from "../../../../Controllers/Suppliers";

const SuppliersTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [previousPage, setPreviousPage] = useState(1);
  const [isSearching, setIsSearching] = useState(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      catalog: headerdata?.catalog,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {

    if (data?.search && !isSearching) {
      setPreviousPage(pagination.currentPage);
      setIsSearching(true);
    }

    if (!data?.search && isSearching) {
      setIsSearching(false);
      fetchData({
        ...data,
        currentPage: previousPage,
        totalCount: pagination?.totalCount,
        totalPages: pagination?.totalPages,
      });
      return;
    }

    let page = data?.search ? 1 : pagination?.currentPage;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};

    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      catalog: headerdata?.catalog,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        catalog: tabledata?.catalog,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const suppliers = await get_all_suppliers(params);

      if (suppliers?.status) {
        let data = [];

        suppliers?.data?.data?.map((value, index) => {
          data?.push({
            path: `/app/suppliers/view/${value?._id}`,
            Name: value?.name,
            Email: value?.email,
            Phone: value?.phone,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/suppliers/edit/${value?._id}`}
                id={value?._id}
                api="delete-supplier"
                actiondata={actiondata}
              />
            ),
          });
        });

        setPagination({
          currentPage: suppliers?.data?.currentPage,
          totalCount: suppliers?.data?.totalCount,
          totalPages: suppliers?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(suppliers?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default SuppliersTable;
